import { Button } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';

import AddMemberModal from './AddMemberModal';

export interface AddMemberButtonProps {
  parentDocument: DocumentWithMembershipStore;
}

function AddMemberButton({ parentDocument }: AddMemberButtonProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        disabled={!parentDocument.canEdit}
        onClick={() => setIsModalVisible(true)}
      >
        Add User
      </Button>

      {parentDocument.canEdit && (
        <AddMemberModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          parentDocument={parentDocument}
        />
      )}
    </>
  );
}

export default observer(AddMemberButton);
